// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ButtonGroupFilter .ButtonGroupFilter-item{border-bottom:3px solid transparent;color:var(--primary);font-family:Open Sans;font-size:10px;padding:1px 0;text-decoration:none;text-transform:uppercase}.ButtonGroupFilter .ButtonGroupFilter-item.active{border-color:var( --warning)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
